
export type CalendarGesture = 'drag' | 'tap';

export type CalendarIntent = 'book' | 'block';

const INSTRUCTION_BY_GESTURE: Record<CalendarGesture, string> = {
  drag: 'Drag to select a time, then confirm. Booked and blocked times are locked.',
  tap: 'Tap a start time, then an end time, then confirm. Booked and blocked times are locked.',
};

export function calendarInstruction(
  gesture: CalendarGesture,
  _intent: CalendarIntent = 'book',
): string {
  return INSTRUCTION_BY_GESTURE[gesture];
}

export type CalendarScope = 'week' | 'day';

export function calendarEmptyLabel({
  scope,
  filtered = false,
}: {
  scope: CalendarScope;
  filtered?: boolean;
}): string {
  const period = scope === 'day' ? 'day' : 'week';
  const verb = filtered ? 'match these filters' : 'scheduled';
  return `No open houses ${verb} this ${period}.`;
}

export const calendarLegendLabel = {
  yourBookings: 'Your bookings',
  yourBooking: 'Your booking',
  otherAgents: 'Other agents',
  yourSelection: 'Your selection',
  blocked: 'Blocked',
} as const;
